const config = {
  API_BASE_URL: '/dev-api'
}

export default config
